import React, { useEffect, useState } from 'react';
import client from '../../api/client';
import { card, inputCls, btnCls } from './LegalConfigEditor';

export default function SuppressionManager({ toast, onChange }) {
  const [rows, setRows] = useState([]);
  const [phone, setPhone] = useState('');
  const load = () => client.get('/admin/compliance/suppressions').then(({ data }) => setRows(data.suppressions)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setSuppressed = async (p, suppressed) => {
    if (!suppressed && !window.confirm(`Un-block ${p}? Only do this if the person texted START or asked in writing.`)) return;
    try {
      await client.post('/admin/compliance/suppressions', { phone: p, suppressed });
      toast({ title: suppressed ? 'Number blocked' : 'Number un-blocked' });
      setPhone(''); load(); onChange?.();
    } catch (e) {
      toast({ title: 'Failed', description: e.message, variant: 'destructive' });
    }
  };

  return (
    <section data-testid="suppression-manager" className={card + ' space-y-3'}>
      <div>
        <h3 className="font-serif text-xl text-[#2A2A2A]">STOP list</h3>
        <p className="text-xs text-[#6A6A6A]">Numbers here are blocked from every outbound text (invites, reminders, digests, broadcasts, vendor texts).</p>
      </div>
      <div className="flex gap-2">
        <input data-testid="suppression-phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+1 555 555 5555" className={inputCls} />
        <button data-testid="suppression-add" disabled={!phone} onClick={() => setSuppressed(phone, true)} className={btnCls + ' whitespace-nowrap'}>Block number</button>
      </div>
      <ul className="text-sm divide-y divide-[#F2E8DE] max-h-64 overflow-auto">
        {rows.length === 0 && <li className="py-2 text-[#9A8A7E] text-xs">No blocked numbers.</li>}
        {rows.map((r) => (
          <li key={r.phone} data-testid={`suppression-row-${r.phone}`} className="py-2 flex items-center justify-between gap-2">
            <div><p className="font-mono text-xs">{r.phone}</p><p className="text-[11px] text-[#9A8A7E]">{r.keyword || r.reason} · {r.source} · {new Date(r.updated_at).toLocaleString()}</p></div>
            <button data-testid={`suppression-remove-${r.phone}`} onClick={() => setSuppressed(r.phone, false)} className="text-[11px] px-3 py-1 rounded-full border border-[#EFE3D8] hover:border-[#7B2C3B]">Un-block</button>
          </li>
        ))}
      </ul>
    </section>
  );
}
